import { Placemark } from '@pbe/react-yandex-maps'
import { YMapsApi } from '@pbe/react-yandex-maps/typings/util/typing'
import { renderToString } from 'react-dom/server'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { Shop } from '@/features/product/choose-pickup-point/types/shop'

import { DISCOUNT_ORDER_SOURCE } from '@/shared/lib/const/order-source'
import { useFastOrderLink } from '@/shared/lib/hooks/useFastOrderLink'

import { MapMarker } from '../../assets/MapMarker'
import { MapBalloon } from '../MapBaloon/MapBalloon'

interface ShopPlacemarkProps {
	shop: Shop
	onSelect: (shop: Shop) => void
	yMap: YMapsApi
	isActive: boolean
	isSelected: boolean
	isDiscountPickup?: boolean
}

const getIconLayout = (shop: Shop, isSelected: boolean) =>
	renderToString(
		<>
			{isSelected && <MapMarker zIndex color="#568DFE" />}
			{!isSelected && <MapMarker />}
		</>
	)

export const ShopPlacemark = (props: ShopPlacemarkProps) => {
	const { shop, isActive, onSelect, isSelected, yMap, isDiscountPickup = false } = props

	const { product } = useProduct()
	const fastOrderLink = useFastOrderLink(
		// @ts-ignore
		product.ID,
		undefined,
		isDiscountPickup ? DISCOUNT_ORDER_SOURCE : undefined
	)
	const iconLayout = () => yMap?.templateLayoutFactory?.createClass(getIconLayout(shop, isSelected))

	const handleCardClick = (): void => {
		setTimeout(() => {
			onSelect(shop)
		}, 100)
	}
	return (
		<>
			<Placemark
				key={shop.NAME}
				geometry={[shop.GPS_N, shop.GPS_S]}
				onClick={handleCardClick}
				properties={{
					hintContent: shop.NAME,
					balloonContentBody: renderToString(
						<MapBalloon shop={shop} isVisible={isActive} fastOrderLink={fastOrderLink} />
					)
				}}
				options={{
					hideIconOnBalloonOpen: false,
					iconLayout: iconLayout(),
					iconOffset: [-12, -28],
					iconShape: {
						type: 'Rectangle',
						// @ts-ignore
						coordinates: [
							[0, 0],
							[28, 38]
						]
					},
					balloonOffset: [-90, 10],
					zIndex: 999,
					balloonAutoPanUseMapMargin: false,
					balloonAutoPanMargin: [0, 0]
				}}
				modules={[`geoObject.addon.hint`, `geoObject.addon.balloon`]}
			/>
		</>
	)
}
